import isEqual from "lodash/isEqual";
import cloneDeep from "lodash/cloneDeep";

function midpoint(clip) {
  return {
    x: clip.x + clip.width / 2,
    y: clip.y + clip.height / 2,
  };
}

function getLocationsToRecreate(grp) {
  const locsByRecord = grp.locations.order.reduce((acc, id) => {
    const loc = grp.locations[id];
    if (!acc[loc.record_id]) {
      acc[loc.record_id] = [];
    }

    acc[loc.record_id].push(loc);
    return acc;
  }, {});

  const docs = grp.documents.order.reduce((acc, id) => {
    const doc = grp.documents[id];
    if (!doc.is_virtual) {
      doc.data.pages.order.forEach((pageId) => {
        const page = doc.data.pages[pageId];
        const [storedPageId, slug] = page.name.split("/");
        if (!acc[storedPageId]) {
          acc[storedPageId] = [];
        }
        acc[storedPageId].push({
          page,
          index: page.page,
          document_id: id,
        });
      });
    }

    return acc;
  }, {});

  const unlocatedItems = [];
  const updatedItemDrawings = [];
  let locCount = grp.locations.order.length;

  grp.items.order.forEach((id) => {
    const item = grp.items[id];
    if (item.drawing?.type !== "iiif") return false;
    const locs = locsByRecord[item.id] || [];

    const linkedLocation = locs.find(
      (l) => l.id === item.drawing.attachment_id,
    );

    const path = item.drawing.path.split("/");
    const [pageId, slug] = path;
    const [_, index] = slug.split(".");
    const pages = docs[pageId];
    const matchingPages =
      pages?.filter((p) => p.index === parseInt(index)) || [];

    const matchClip = locs.find((l) => {
      const mp = matchingPages.find((p) => p.page.id === l.page_id);
      return mp && isEqual(item.drawing.clip, l.clip);
    });

    if (!linkedLocation && !matchClip && item.drawing.attachment_id) {
      const mustReassignId = grp.locations[item.drawing.attachment_id];

      const locations = matchingPages.map((p, i) => ({
        id:
          i !== 0 || mustReassignId
            ? crypto.randomUUID()
            : item.drawing.attachment_id,
        document_id: p.document_id,
        index: locCount + i + 1,
        type: "pin",
        record_id: item.id,
        record_type: item.is_collection ? "collection" : "item",
        group_id: grp.id,
        page_id: p.page.id,
        clip: item.drawing.clip,
        position: midpoint(item.drawing.clip),
      }));

      if (mustReassignId) {
        const id = locations[0].id;
        const drawing = cloneDeep(item.drawing);
        drawing.attachment_id = id;
        updatedItemDrawings.push({ id, drawing });
      }

      locCount += matchingPages.length;

      if (locations.length) {
        unlocatedItems.push({
          item,
          locations,
        });
      }
      return true;
    }
  });

  const items = grp.items.order.filter((id) => {
    const item = grp.items[id];
    return !item.is_collection;
  });

  const collections = grp.items.order.filter((id) => {
    const item = grp.items[id];
    return item.is_collection;
  });

  return { unlocatedItems, updatedItemDrawings, items, collections };
}

function locationsToRecreate(grp) {
  const { unlocatedItems, items, collections } = getLocationsToRecreate(grp);
  let content = `
Total number of items: ${items.length}
Total number of openings: ${collections.length}
Number of recreatable items & openings: ${unlocatedItems.length}
  `;
  console.log(content);

  if (unlocatedItems.length) {
    const table = unlocatedItems.map(({ item, locations }) => {
      return {
        Mark: item.mark,
        ["Opening/Item"]: item.is_collection ? "Opening" : "Item",
        ["New markers"]: locations.length,
      };
    });
    console.table(table);
  }
}

function recreateLocations(grp) {
  const { unlocatedItems, updatedItemDrawings } = getLocationsToRecreate(grp);
  const updates = [];

  if (unlocatedItems.length) {
    const update = unlocatedItems.reduce(
      (acc, { locations }) => {
        acc.records.push(...locations);
        return acc;
      },
      { type: "location", action: "add", records: [], block: true },
    );
    updates.push(update);
  }

  updatedItemDrawings.forEach(({ id, drawing }) => {
    updates.push({ id, type: "item", prop: "drawing", value: drawing });
  });

  return updates;
}

export { locationsToRecreate, recreateLocations };
